export const TRAJECTORY_CREATE_STATUS = {
  SUBMITTED: 'SUBMITTED',
  PENDING: 'PENDING',
  RUNNABLE: 'RUNNABLE',
  STARTING: 'STARTING',
  RUNNING: 'RUNNING',
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED',
} as const
export type TrajectoryCreateStatusType = typeof TRAJECTORY_CREATE_STATUS[keyof typeof TRAJECTORY_CREATE_STATUS];
export const TRAJECTORY_CREATE_STATUS_PROGRESS = {
  [TRAJECTORY_CREATE_STATUS.SUBMITTED]: 0,
  [TRAJECTORY_CREATE_STATUS.PENDING]: 10,
  [TRAJECTORY_CREATE_STATUS.RUNNABLE]: 20,
  [TRAJECTORY_CREATE_STATUS.STARTING]: 30,
  [TRAJECTORY_CREATE_STATUS.RUNNING]: 70,
  [TRAJECTORY_CREATE_STATUS.SUCCEEDED]: 100,
  [TRAJECTORY_CREATE_STATUS.FAILED]: 0,
}

// --------------------------------------------------------------------------------------
/**
 * 軌道生成 API関連の型定義
 */
export interface TrajectoryCreate {
  zipURI: string;
}
export interface TrajectoryCreateDocument {
  createId: string;
  jobId: string;
}
// --------------------------------------------------------------------------------------
/**
 * 軌道生成ポーリング API関連の型定義
 */
export interface TrajectoryPoll {
  createId: string;
  jobId: string;
}
export interface TrajectoryPollDocument {
  status: TrajectoryCreateStatusType;
  result:{
    trajectory:string;
    "s3-uri":{
      video:string;
    }
  }
}
